import PropTypes from 'prop-types'
import React from 'react'

import { BrandHeader } from '../../components/header'
import { Loader } from '../../components/loader/Loader'
import Page from '../../components/page/Page'
import { Column, FlexWrapper, NarrowWrapper } from '../common'

const LoadingPage = ({ navigation }) => (
  <Page loading navigation={navigation} header={BrandHeader}>
    <NarrowWrapper>
      <FlexWrapper>
        <Column>
          <Loader />
        </Column>
      </FlexWrapper>
    </NarrowWrapper>
  </Page>
)

LoadingPage.defaultProps = {
  navigation: true,
}

LoadingPage.propTypes = {
  navigation: PropTypes.bool,
}

export default LoadingPage
